import {
  resourceState,
  resourceMutations,
  resourceGetters,
  resourceActions,
} from '@/store/utils/resource';
import { PEOPLE } from '@/store/entities/schema_types';
import { accountPeopleClient as client } from '@/api/clients';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  getters: resourceGetters('people'),
  actions: {
    ...resourceActions,
    async load(ctx, { id, query = {} }) {
      try {
        const response = await client.list(id, query);

        const { data, meta } = response;

        const personIds = await ctx.dispatch(
          'entities/persistEntities',
          { type: PEOPLE, data },
          { root: true }
        );

        ctx.commit({
          type: 'setIdsByParent',
          parentId: id,
          ids: personIds,
        });

        return Promise.resolve({ personIds, meta });
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },
    async store(ctx, { id, formData }) {
      try {
        const response = await client.store(id, mapKeysToSnakeCase(formData));

        const personId = await ctx.dispatch(
          'entities/persistEntities',
          { type: PEOPLE, data: response.data },
          { root: true }
        );

        return Promise.resolve(personId);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
